import * as React from 'react';
import styled from 'styled-components';

export const CardStickerStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 70px;
  position: absolute;
  right: 19px;
  top: -18px;
  background: url('https://cdn.reeltime.no/pm_assets/img/xnyeboliger.jpg.pagespeed.ic.oDQzsWQg6E.jpg')
    center center / cover no-repeat;
  
  &.sold {
    background: url('https://pm2019.reeltime.no/public/images/sold_tag.ef5ae0db.png')
    center center / cover no-repeat;
  }
`;

export const CardSticker: React.FC<{ sold?: boolean }> = ({ sold }) => {
  return <CardStickerStyle className={sold ? 'sold' : ''} ></CardStickerStyle>;
};
